import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { handleDemoFormOrBot } from './components/get-a-demo.js';
import { screenSize } from './components/screen-sizes.js';

const pricingToggle = document.querySelector('#togglePrice');
const togglePriceContainer = document.querySelector('.slider-toggle-container');
const businessCta = document.querySelector('#price-card-business button');
const businessMinSeats = 7;
let countryLanguage = 'US';
let currencyCode = 'USD';
let currencySymbol = '$';
let prices = {
  pro: {},
  pro_team: {}
};
let selectedPlan = 'pro';
let selectedSeats = 1;

document.addEventListener("DOMContentLoaded", function () {
  setEventListeners();
  setPricesAccordingToLocation();

  slickSliderGenerator('brand', '.logos-container');
  displayBrandSliderOnLoad();
  slickSliderGenerator('testimonials', '.testimonials-container');
  slickSliderGenerator('features', '.features-container');
  accordion('.faqs-cards');
  accordion('.plan-features-inner');
  showMoreFaqs();
  getSVG();

  handleDemoFormOrBot();
  openFaqBusinessOnAnchorClick();
  displayToolTipListeners();
});

function openFaqBusinessOnAnchorClick() {
  const button = document.querySelector('[href="#faqs-add-user"]');
  const faqTarget = document.getElementById('faqs-business');
  document.querySelector('.plan-calculator .team-size-input').type = 'number';

  button.addEventListener('click', e => {
    e.preventDefault();

    faqTarget.scrollIntoView(({ behavior: 'smooth', block: 'start', inline: 'nearest' }));
    setTimeout(() => faqTarget.click(), 300);
  });
}

function displayToolTipListeners() {
  const toolTipIcon = document.querySelectorAll('.tooltip-icon');
  const toolTipContainer = document.querySelector('.tooltip-container');

  toolTipIcon.forEach( activeToolTipIcon => {
    activeToolTipIcon.addEventListener('mouseenter', function() {
      this.closest('.checklist-element.active').classList.add('show-tooltip');
      getToolTipIconPosition(toolTipContainer, activeToolTipIcon);
    });

    activeToolTipIcon.addEventListener('mouseleave', function() {
      this.classList.remove('active');
      toolTipContainer.classList.remove('active');
      this.closest('.checklist-element.active').classList.remove('show-tooltip');
    });
  });
}

function getToolTipIconPosition(toolTip, toolTipIcon) {
  const card = document.querySelector('#price-card-business');
  const cardPosition = card.getBoundingClientRect();
  const toolTipPosition = toolTip.getBoundingClientRect();
  const toolTipIconPosition = toolTipIcon.getBoundingClientRect();
  const toolTipContainerHeight = toolTip.offsetHeight + 10;
  const alignTooltipToRight = window.innerWidth < screenSize.laptop || (window.innerWidth > screenSize.laptop && window.innerWidth < screenSize.hdReady);

  toolTip.style.top = `${(toolTipIconPosition.top - cardPosition.top) - toolTipContainerHeight }px`;
  toolTip.style.left = alignTooltipToRight ? '5%' : '25%';

  toolTip.classList.add('active');
}


function setEventListeners() {
  _setToggleListeners();
  _setCalculatorListeners();
}

function _setToggleListeners() {
  const monthlyButton = document.querySelector('.slider-toggle-container .payment-select-monthly');
  const yearlyButton = document.querySelector('.slider-toggle-container .payment-select-yearly');
  pricingToggle.addEventListener('click', () => togglePricing());
  pricingToggle.parentNode.addEventListener('touchend', (e) => {
    e.preventDefault();
    pricingToggle.checked = !pricingToggle.checked;
    togglePricing();
  });

  monthlyButton.addEventListener('click', () => {
    togglePriceContainer.classList.remove('active');
    pricingToggle.checked = false;
    setPrices();
  });

  yearlyButton.addEventListener('click', () => {
    togglePriceContainer.classList.add('active');
    pricingToggle.checked = true;
    setPrices();
  });
}

function _setCalculatorListeners() {
  const teamSeatsInput = document.querySelector('.plan-calculator .team-size-input');

  if (teamSeatsInput) {
    teamSeatsInput.addEventListener('focus', e => preventAutoComplete(e));
    teamSeatsInput.addEventListener('active', e => preventAutoComplete(e));

    teamSeatsInput.addEventListener('keyup', e => sanitiseSeats(e));
    teamSeatsInput.addEventListener('change', e => sanitiseSeats(e));
  }

  function sanitiseSeats (e) {
    let seats = 1;
    seats = (e.target.value <= 0 || e.target.value === '' ) ? 1 : e.target.value;

    updateCardPrices(seats);
  }
}

function updateCardPrices(seats) {
  selectedSeats = seats;
  setPrices(seats);

  businessCta && businessCta.setAttribute('data-selected-seats', seats);

  const plan = seats >= businessMinSeats ? 'business' : 'pro';
  if (plan !== selectedPlan) {
    selectedPlan = plan;
    _resetPlans();
    _selectPlan(plan);
  }
}

function preventAutoComplete(e){
  e.target.type = 'number'
} // Hack to avoid autocomplete in Chrome

function _resetPlans() {
  const cards = document.querySelectorAll('.pricing-plan-card');

  cards.forEach((card) => {
    card.classList.contains('selected') && card.classList.remove('selected');

    const cta = card.querySelector('button');
    cta.classList.add('outline');
    cta.classList.remove('primary');

    const descriptionReplacements = card.querySelectorAll('.price-description');
    if (descriptionReplacements.length > 1)
      descriptionReplacements.forEach(block => block.classList.toggle('active'));
  });
}

function _selectPlan(planId) {
  const planCard = document.querySelector(`#price-card-${planId}`);

  planCard.classList.add('selected');
  const cta = planCard.querySelector('button');
  cta.classList.remove('outline');
  cta.classList.add('primary');
}

function togglePricing() {
  togglePriceContainer && togglePriceContainer.classList.toggle('active');

  setPrices(selectedSeats);
  toggleSpecialNotes();
}

function setPricesAccordingToLocation() {
  const cards = document.querySelectorAll('.pricing-plan-card');
  let locationData;

  getDataFromIp()
    .then(location => {
      locationData = location;
    })
    .catch(e => {
      locationData = {
        currency: {
          code: 'usd',
          symbol_native: '$'
        },
        location: {
          language: {
            code: 'en'
          }
        }
      }
    })
    .finally(() => {
      getPrices().then(function () {
        setCurrency(locationData);
        setPrices();

        cards.forEach(element => {
          element.classList.add('active');
        });
      })
    });
}

function toggleSpecialNotes() {
  const billingNote = document.querySelectorAll('.plan-period-note');
  const pricingPlansNotes = document.querySelectorAll('.plan-actions-notice');

  [...billingNote, ...pricingPlansNotes].forEach(item => item.classList.toggle('active'));
}

function getPrices() {
  const endpoint = `${CONFIG.desygner_api}payment/prices/plans`;

  return new Promise(function (resolve, reject) {
    Promise.all([
      fetch(endpoint + '/pro'),
      fetch(endpoint + '/pro_team')
    ])
      .then(function (responses) {
        return Promise.all(responses.map(function (response) {
          return response.json();
        }));
      })
      .then(function (data) {
        if (data.length > 0) {
          prices.pro = data[0];
          prices.pro_team = data[1];
          resolve();
        }
      })
      .catch(function (error) {
        reject();
      });
  });
}

function getDataFromIp() {
  const ipLookup = localStorage.getItem('ip-lookup');

  return new Promise(function (resolve, reject) {
    if (ipLookup) {
      return resolve(JSON.parse(ipLookup));
    }

    getLocation().then(location => {
        return location ? resolve(location) : reject();
      })
      .catch(e => { reject(); });
  });
}

function getLocation() {
  const endpoint = `${CONFIG.desygner_api}business/ip-lookup`;

  return new Promise(function (resolve, reject) {
    if (localStorage.getItem('ip-lookup')) {
      resolve(localStorage.getItem('ip-lookup'));
    }

    fetch(endpoint)
      .then(response => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          throw Error(response.statusText);
        }
      })
      .then(data => resolve(data))
      .catch(error => reject(error));
  });
}

function setCurrency(locationData) {
  const data = locationData.data || locationData;
  countryLanguage = data.location.language.code;
  const currencyExists = data && data.currency;
  const plansHaveCurrency = prices.pro.prices[data.currency.code.toLowerCase()]
    && prices.pro_team.prices[data.currency.code.toLowerCase()];

  if (currencyExists && plansHaveCurrency) {
    currencyCode = data.currency.code;
    currencySymbol = data.currency.symbol_native;
  }
}

function setPrices(seats = 1) {
  const freePriceContainer = document.querySelector('#price-card-free .plan-price');
  const proPriceContainer = document.querySelector('#price-card-pro .plan-price');
  const proTeamPriceContainer = document.querySelector('#price-card-business .plan-price');
  const proTeamSeats = document.querySelector('#price-card-business .seats');
  const currencyName = document.querySelectorAll('.plan-currency');
  const bonusValue = document.querySelector('.bonus-value');
  const currencyCodeLower = currencyCode.toLowerCase();
  const interval = togglePriceContainer.classList.contains('active') ? 'year' : 'month';

  const currencyOptions = new Intl.NumberFormat(countryLanguage, {
    style: 'currency',
    currency: currencyCode,
  }).resolvedOptions();

  let totalPrice = 0;
  const proPrices = {
    month: getTotalPrice('pro', 1, currencyCodeLower, '1_month', totalPrice),
    year: getTotalPrice('pro', 1, currencyCodeLower, '1_year', totalPrice) / 12
  };

  const proTeamPrices = {
    month: getTotalPrice('pro_team', seats, currencyCodeLower, '1_month', totalPrice),
    year: getTotalPrice('pro_team', seats, currencyCodeLower, '1_year', totalPrice) / 12
  };

  if (freePriceContainer)
    freePriceContainer.innerHTML = _priceToLocale(0, countryLanguage, currencyOptions);

  if (proPriceContainer)
    proPriceContainer.innerHTML = _priceToLocale(proPrices[interval], countryLanguage, currencyOptions);

  if (proTeamPriceContainer)
    proTeamPriceContainer.innerHTML = _priceToLocale(proTeamPrices[interval], countryLanguage, currencyOptions);

  if (bonusValue)
    bonusValue.innerHTML = `${currencySymbol}${currencySymbol}${currencySymbol}`;

  if (proTeamSeats) proTeamSeats.innerHTML = selectedSeats;

  Array.from(currencyName).forEach(function (label) {
    label.innerHTML = currencyCode || 'USD';
  });
}

function getTotalPrice(plan, seats, currency, interval, accum) {
  if (prices[plan].is_tiered) {
    const intervalPrices = prices[plan].prices[currency][interval];
    let currentSeats = seats;

    const tier = intervalPrices.find(tier => (seats >= tier.from_unit && seats <= tier.to_unit));
    const tierSeats = currentSeats - tier.from_unit + 1;
    const tierPrice = tier.is_flat ? tier.amount : tierSeats * tier.amount;
    const remainingSeats = currentSeats - tierSeats;
    accum += tierPrice;

    return (remainingSeats > 0) ? getTotalPrice(plan, remainingSeats, currency, interval, accum) : accum;
  }
  else {
    return prices[plan].prices[currency][interval][0].amount * seats;
  }
}

function _priceToLocale(price, language, options) {
  return price.toLocaleString(language, options).replace(/[^.,0-9]/g, '') || '';
}
